import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
HttpClient
@Injectable({
	providedIn: 'root',
})
export class ProductsService {
	constructor(private http: HttpClient) {}

	getProductsList(body: any) {
		return this.http.post(`${ApiEndPoint.getProductListApi}`, body)
	}
	getProductDetails(id: any) {
		return this.http.get(`${ApiEndPoint.getProductDetailsApi}?id=${id}`)
	}
	getCategoryList(SearchText: string | null, categoryId?: Number | null) {
		return categoryId
			? this.http.get(
					`${ApiEndPoint.getAllProductCategoryApi}?categoryId=${categoryId}&SearchText=${SearchText}`
			  )
			: this.http.get(
					`${ApiEndPoint.getAllProductCategoryApi}?SearchText=${SearchText}`
			  )
	}
	getSubcategoryList(body: any) {
		return this.http.get(`${ApiEndPoint.getSubcategoryListApi}`, body)
	}
	getBrandList(searchText: String) {
		return this.http.get(
			`${ApiEndPoint.getBrandListApi}?SearchText=${searchText}`
		)
	}
	getRelatedProduct(body: any) {
		return this.http.post(`${ApiEndPoint.getRelatedProduct}`, body)
	}
	addProduct(body: any) {
		return this.http.post(`${ApiEndPoint.addProductApi}`, body)
	}
	uploadProductPhoto(body: any) {
		return this.http.post(`${ApiEndPoint.uploadProductPhotoApi}`, body)
	}
	isSkuUnique(name: any) {
		return this.http.post(`${ApiEndPoint.isSkuUnique}?nameEn=${name}`, '')
	}

	updateProductDetails(body: any) {
		return this.http.put(`${ApiEndPoint.updateProductDetailsApi}`, body)
	}
	updateProductImages(body: any) {
		return this.http.put(`${ApiEndPoint.updateProductImages}`, body)
	}
	updateProductVariantImages(body: any) {
		return this.http.put(`${ApiEndPoint.updateProductVariantImages}`, body)
	}
	changeProductActivationStatus(id: string, isActive: boolean) {
		return this.http.post(
			`${ApiEndPoint.updateProductStatusApi}?id=${id}&isActive=${isActive}`,
			''
		)
	}
	changeProductVariantActivationStatus(id: string, isActive: boolean) {
		return this.http.post(
			`${ApiEndPoint.updateProductVariantStatusApi}?id=${id}&isActive=${isActive}`,
			''
		)
	}
	getProductVariantType() {
		return this.http.get(`${ApiEndPoint.getProductVariantTypeApi}`)
	}
	SearchAllTabCount(filter: any) {
		return this.http.post(ApiEndPoint.getActiveCountApi, filter)
	}
	createProductPromoCode(body: any) {
		return this.http.post(ApiEndPoint.createProductPromoCodeApi, body)
	}
	getFilteredProducts(body: any) {
		return this.http.post(ApiEndPoint.getFilteredPromoCodeProductsApi, body)
	}
	getProductPromocodeList(body: any) {
		return this.http.post(ApiEndPoint.getProductPromocodeListApi, body)
	}
	checkCodeUnique(code: string, Id?: string | null) {
		return Id
			? this.http.get(`${ApiEndPoint.checkCodeUniqueApi}?code=${code}&Id=${Id}`)
			: this.http.get(`${ApiEndPoint.checkCodeUniqueApi}?code=${code}`)
	}
	exportProductsToExcel(body: any) {
		return this.http.post(ApiEndPoint.exportProductsToExcelApi, body)
	}
	getPromocodeDetails(id: string) {
		return this.http.get(
			`${ApiEndPoint.getPromocodeDetailsApi}?promoCodeID=${id}`
		)
	}
	editPromoCode(body: any) {
		return this.http.post(`${ApiEndPoint.editPromocodeApi}`, body)
	}
	deletePromocode(id: string) {
		return this.http.delete(`${ApiEndPoint.deletePromocodeApi}?id=${id}`)
	}
	activateDeactivatePromocodde(id: string, isActive: boolean) {
		return this.http.put(
			`${ApiEndPoint.activateDeactivatePromocodeApi}?id=${id}&isActive=${isActive}`,
			{}
		)
	}
}
